<template>
    <section id="home_content"
        class="w-100 vh-100 d-flex flex-column justify-content-center align-items-center text-center">

        <div class="container">

            <h1>ذكاء القابضة</h1>

            <h3>منظومة متكاملة في التعليم والتطوير والتصنيع والاستثمار</h3>

            <div id="paragraph_wrapper" class="d-flex justify-content-center align-items-center">
                <p>نستلهم في ذكاء القابضة شغفنا من رؤية المملكة لنصبح الخيار الأول في تقديم وابتكار مختلف الحلول التقنية
                    المتكاملة لتحقيق التحول المطلوب في مختلف المجالات للقطاعات الحكومية والخاصة. نقدم مجموعة شاملة من خدمات
                    البرمجيات التي تلبي جميع احتياجات أعمالك.</p>
            </div>

            <div id="button_wrapper" class="d-flex justify-content-center align-items-center">
                <router-link :to="{ name: 'about' }" class="btn d-flex justify-content-center align-items-center">
                    عرض المزيد
                    <font-awesome-icon :icon="['fas', 'fa-arrow-up']" class="me-3" />
                </router-link>
            </div>

            <div id="img_right_wrapper">
                <img src="@/assets/images/home/right_img.webp" alt="">
            </div>

            <div id="img_left_wrapper">
                <img src="@/assets/images/home/left_img.webp" alt="">
            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'Home',
}
</script>

<style lang="scss" scoped>
#home_content {

    position: relative;

    .container {

        h1 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 64px;
            line-height: 100%;

            @include breakpoints(x-small) {
                font-size: 32px;
            }

            @include breakpoints(small) {
                font-size: 32px;
            }
        }

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Light-Primary;
            font-size: 24px;
            line-height: 180%;

            @include breakpoints(x-small) {
                font-size: 18px;
            }

            @include breakpoints(small) {
                font-size: 18px;
            }
        }

        #paragraph_wrapper {

            // width: 100%;

            p {
                color: $White;
                font-size: 18px;
                line-height: 180%;
                // text-align: justify;
                // width: 680px;
                width: 500px;

                @include breakpoints(x-small) {
                    font-size: 16px;
                    // width: 100%;
                    // width: 343px;
                    width: 450px;
                }

                @include breakpoints(small) {
                    font-size: 16px;
                }
            }

        }

        #button_wrapper {

            a {
                // width: 151.724px;

                padding: 4px 8px;

                color: $White;
                font-size: 18px;
                line-height: 180%;

                border-radius: 8px;

                background: $Linear-Blue;
                background-clip: padding-box;
                -webkit-background-clip: padding-box;
                -webkit-text-fill-color: $White;

                @include breakpoints(x-small) {
                    font-size: 16px;
                }

                @include breakpoints(small) {
                    font-size: 16px;
                }

                svg {
                    font-size: 18px;
                    // CSS Vendor Prefixes
                    -webkit-transform: rotate(-45deg);
                    -moz-transform: rotate(-45deg);
                    -o-transform: rotate(-45deg);
                    -ms-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                }
            }

        }

        #img_right_wrapper,
        #img_left_wrapper {

            @include breakpoints(x-small) {
                visibility: hidden;
            }

            @include breakpoints(small) {
                visibility: hidden;
            }

            @include breakpoints(medium) {
                visibility: hidden;
            }

            @include breakpoints(large) {
                visibility: hidden;
            }

            img {
                width: 100%;
                height: 100%;
                // object-fit: cover;
                object-fit: contain;
            }
        }

        #img_right_wrapper {
            width: 222.374px;
            height: 740px;
            position: absolute;
            right: 0;
            top: 140px;
        }

        #img_left_wrapper {
            width: 235.082px;
            height: 740px;
            position: absolute;
            left: 0;
            top: 140px;
        }

    }

}
</style>